<template>
    <header class="navbar">
        <div class="logo-wrap">
            <svg width="95" height="29" viewBox="0 0 95 29" xmlns="http://www.w3.org/2000/svg">
                <defs>
                    <linearGradient x1="4.442%" y1="50%" x2="95.558%" y2="78.011%" id="a">
                        <stop stop-color="#F87B02" offset="0%" />
                        <stop stop-color="#F83A01" offset="62.988%" />
                        <stop stop-color="#FF4500" offset="100%" />
                        <stop stop-color="#FF4500" offset="100%" />
                    </linearGradient>
                </defs>
                <g fill-rule="nonzero" fill="none">
                    <path
                        d="M93.276 25.559v2.454h-5.039v-2.454h5.039zm-31.32.511l.168 1.535h.174v.408h-1.115l-.229-1.943h1.001zm-3.396 0l-.228 1.943h-1.149v-.408h.207l.174-1.535h.996zm3.733-2.715v.566h-4.108v1.47h1.17v-1.16h.995v1.16h1.948v.407H60.35v2.215h-1.583v-.408h.588v-1.807h-2.166v-2.285h4.092v-.158h1.012zm-7.76 2.378v2.28h-5.092v-2.28h5.093zm30.94-2.389v.408h-1.98v1.807h.652l.207-1.502h.941l-.201 1.502h.468v.408h-2.068v2.013h-.98v-2.013h-2.067v-.408h.468l-.201-1.502h.946l.202 1.502h.653v-1.807h-1.98v-.408h4.94zm-47.612.8l.158.512.163-.512h.833l-.577 1.84.495 1.577h.098v.408h-.838l-.19-.604-.19.604h-.828v-.408h.12l.479-1.523-.593-1.894h.87zm31.93 1.077v2.748h-2.329v-.408h1.35v-1.937h-2.068l-.376 2.345h-1.43v-.408h.516l.305-1.937h-.822v-.403h4.854zm-34.808.387v.212h.74v-.212h.909v.212h.163v.403h-.163v.756l-.577.337.44.25h.23v.403h-.948l-.424-.25-.424.25h-.93v-.402h.184l.452-.262-.566-.326v-.756h-.136v-.403h.136v-.212h.914zm11.557-.898v.403l-.593.876h.844v.402h-.599v1.567h-4.348v-.408h3.347v-1.159h-3.515v-.402h3.129l.604-.876h-3.565v-.403h4.696zm27.147-1.333v.822h.201l.25-.822h1.045l-.255.822h1.806v-.822h1.045V24.6h-2.977l-.114.365h3.09v.402l-1.055 1.295.854.882h.202v.413h-1.067l-.566-.593-.484.593H74.08v-.408h.696l.713-.892-.838-.892h1.208l.185.195.473-.593h-1.953l-.805 2.59H72.69v-.408h.174l.898-2.949h-1.056v-1.224h.98zm-20.084 3.7h-3.232v.528h3.232v-.528zm38.693-1.11h-3.08v1.638h3.08v-1.638zm-56.573.256h-.74v.468l.36.206.38-.217v-.457zm17.88-.087h-3.232v.533h3.232v-.533zm-18.832-1.562l-.076.936h-.762v-.408h.087l.043-.528h.708zm-.104-1.197l.087.653h.196v-.653h.811v.653h.19l.098-.653h.708l-.093.653h.13v.402h-1.033v1.045h-.81v-1.045h-1.018v-.402h.114l-.087-.653h.707zm16.03.767l.19.903h2.194l.196-.903h.92l-.197.903h.544v.408H49.43v-.408h.538l-.19-.903h.92zm-14.06.376l.038.533h.104v.402h-.784l-.076-.935h.718zm53.216-1.143l-.571 1.502h2.982l-.196-1.502h.98l.238 1.91h-5.065v-.408l.571-1.502h1.061zm-23.474 0l-.386 1.567h-1.056v-.408h.164l.26-1.16h1.018zm3.238 0l.272 1.159h.163v.408h-1.055l-.273-1.159H66.64v-.408h2.977zm-24.878-.044v.18h2.046v.887h-.98v-.479h-3.144v.479h-.98v-.887h2.046v-.18h1.012zm7.754.044v.174h2.051v.408H49.43v-.408h2.046v-.174h1.017zm-14.67 0v.136h1.208v.408H36.91v-.544h.914zm3.554-21.64a8.842 8.842 0 1 1 0 17.684h-2.721v-2.72h2.72a6.121 6.121 0 0 0 .181-12.24l-.18-.004h-4.762v14.964h-2.72V1.737h7.482zm30.544.95l.029.109 3.856 16.625h-2.758L70.191 7.335l-5.13 11.289c-.468 1.028-1.895 1.062-2.426.103l-.052-.103-5.13-11.29-2.758 12.087h-2.91l3.909-16.625c.28-1.233 1.925-1.436 2.514-.363l.05.102 5.564 12.239 5.563-12.24c.523-1.15 2.175-1.018 2.536.153zm9.585-.95v7.482h9.522V1.737h2.721V19.42h-2.72V11.94h-9.523v7.482h-2.72V1.737h2.72z"
                        fill="#FFF"
                    />
                    <path
                        d="M12.632 0c7.673 0 13.894 6.22 13.894 13.895 0 7.674-6.22 13.894-13.894 13.894h-1.264V17.684h1.895a3.79 3.79 0 0 0 .142-7.576l-.142-.003h-3.79V27.79H0V0h12.632z"
                        fill="url(#a)"
                        transform="translate(0 1)"
                    />
                </g>
            </svg>
        </div>
        <div class="nav-menu-left">
            <el-link href :underline="false" class="nav-menu-left_btn" @click.prevent="toHome">{{ $t('page.navbar.home') }}</el-link>
            <el-link href :underline="false" class="nav-menu-left_btn" @click.prevent="toDynamic">{{ $t('page.navbar.dynamic') }}</el-link>
            <el-link href :underline="false" class="nav-menu-left_btn" @click.prevent="toAboutUs">{{ $t('page.navbar.aboutUs') }}</el-link>
        </div>
        <div class="nav-menu-right">
            <div class="nav-menu-right_bell" @click="toMsg">
                <span>{{ $t('page.navbar.msg', {m: msg}) }}</span>
            </div>
            <el-dropdown class="nav-menu-right_user" @command="handleCommand">
                <span class="el-dropdown-link nav-right-action_inner">
                    <span>{{ user.name }}</span>
                    <i class="el-icon-arrow-down"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="logout">{{ $t('page.navbar.logOut') }}</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
    </header>
</template>

<script>
import {removeToken} from '@/utils/auth';
import {loginOut} from '@/api/user';

export default {
    data() {
        return {};
    },
    computed: {
        user() {
            return this.$store.getters.user || {};
        },
        msg() {
            return this.$store.getters.msg;
        }
    },
    created() {},
    methods: {
        handleCommand(command) {
            switch (command) {
                case 'logout':
                    this.logout();
                    break;
                default:
                    this.$router.push({path: command});
                    break;
            }
        },
        // 查看消息
        toMsg() {
            this.$router.push({name: 'message'});
        },
        // 前端登出
        async logout() {
            const res = await loginOut();

            if (!res.data.state) {
                return this.$messageError(res);
            }

            removeToken();
            this.$store.dispatch('user/setUserInfo', null);
            this.$router.replace({name: 'login'});
        },
        toHome() {
            location.href = '/';
        },
        toDynamic() {
            location.href = '/news';
        },
        toAboutUs() {
            location.href = '/about';
        }
    }
};
</script>

<style lang="scss" scope>
.navbar {
    height: 60px;
    line-height: 60px;
    background-color: #232a34;
    box-shadow: 0px 1px 0px 0px #ebeef5;

    .logo-wrap {
        display: inline-block;
        width: 240px;
        height: 100%;
        line-height: 60px;
        vertical-align: middle;

        svg {
            display: inline-block;
            margin-left: 20px;
            vertical-align: middle;
        }
    }
}

.nav-menu-left {
    display: inline-block;
    margin-left: 40px;
    height: 100%;
    vertical-align: middle;

    .nav-menu-left_btn {
        margin: 0 30px;
        color: #c0c4cc;
        transition: color 0.3s;

        &:hover {
            color: #fff;
        }
    }
}

.nav-menu-right {
    float: right;
    height: 100%;

    .nav-menu-right_bell {
        display: inline-block;
        padding: 0 15px;
        height: 100%;
        color: #c0c4cc;
        cursor: pointer;
        transition: color 0.3s;
        font-size: 12px;

        &:hover {
            color: #fff;
        }
    }

    .nav-menu-right_user {
        display: inline-block;
        padding: 0 15px 0 15px;
        height: 100%;
        color: #c0c4cc;
        cursor: pointer;
        transition: color 0.3s;

        &:hover {
            color: #fff;
        }

        .el-dropdown-link {
            display: inline-block;
            height: 100%;
            font-size: 12px;
        }
    }
}
</style>
